import { createContext, useState, useContext, useEffect } from 'react';
import i18n from '../i18n';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'bg');

  useEffect(() => {
    changeLanguage(language); // Ensure the initial language is applied
  }, []);

  const changeLanguage = (lng) => {
    console.log("Setting language to:", lng); // Debug log
    i18n.changeLanguage(lng);
    document.documentElement.lang = lng;
    setLanguage(lng);
    localStorage.setItem('language', lng); // Save selected language in localStorage
    console.log("Saved to localStorage:", localStorage.getItem('language')); // Verify save
  };

  return (
      <LanguageContext.Provider value={{ language, changeLanguage }}>
        {children}
      </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
